import { IStockReserved } from '../interfaces/reserved';
import * as baseAdapter from './baseAdapter';

export const queryStockReserveds = async () => {
  const ret = await baseAdapter.get<IStockReserved[]>('/stockReserved/gets');
  return ret;
};

export const getStockReserved = async (id: number) => {
  const ret = await baseAdapter.get<IStockReserved>(`/stockReserved/get/${id}`);
  return ret?.data;
};

export const getStockReservedsByStockId = async (stockId: number) => {
  const ret = await baseAdapter.get<IStockReserved[]>(
    `/stockReserved/getByStockId/${stockId}`,
  );
  return ret;
};

export const addStockReserved = async (data: Partial<IStockReserved>) => {
  const ret = await baseAdapter.post<IStockReserved>(
    '/stockReserved/create',
    data,
  );
  return ret;
};

export const editStockReserved = async (data: Partial<IStockReserved>) => {
  const ret = await baseAdapter.put(`/stockReserved/update`, data);
  return ret;
};

export const deleteStockReserved = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/stockReserved/delete/${id}`);
  return ret;
};
